var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74982 4C7.74982 3.58579 7.41403 3.25 6.99982 3.25C6.5856 3.25 6.24982 3.58579 6.24982 4V5.81643C4.75674 6.02751 3.57719 7.20845 3.37752 8.71484L3.29097 9.36779C3.27629 9.47849 3.26226 9.58926 3.24887 9.70008C3.21335 9.99405 3.44496 10.25 3.74107 10.25H20.2585C20.5546 10.25 20.7862 9.99405 20.7507 9.70008C20.7373 9.58926 20.7233 9.47849 20.7086 9.36779L20.6221 8.71484C20.4224 7.20847 19.2429 6.02754 17.7498 5.81644V4C17.7498 3.58579 17.414 3.25 16.9998 3.25C16.5856 3.25 16.2498 3.58579 16.2498 4V5.66763C13.4221 5.4158 10.5776 5.4158 7.74982 5.66763V4Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9444 12.2256C20.9356 11.9591 20.7155 11.75 20.4489 11.75H3.55068C3.28411 11.75 3.06395 11.9591 3.05519 12.2256C2.99579 14.0332 3.10559 15.8446 3.38433 17.6359C3.59534 18.9919 4.697 20.0335 6.06274 20.1681L7.25574 20.2858C10.4108 20.5969 13.5888 20.5969 16.7438 20.2858L17.9368 20.1681C19.3026 20.0335 20.4042 18.9919 20.6152 17.6359C20.894 15.8446 21.0038 14.0332 20.9444 12.2256Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/CalendarGrey.737916c89ba26aaf117ae4fb5c72bdba.svg";
export { ForwardRef as ReactComponent };